import { useMemo } from 'react';

export interface UseNavigationFooterProps {
  currentStep: number;
  isNextDisabled: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onSaveDraft?: () => void;
  editMode?: boolean;
  recordToEdit?: any;
}

export const useNavigationFooter = ({
  currentStep,
  isNextDisabled,
  onPrevious,
  onNext,
  onSaveDraft,
  editMode = false,
  recordToEdit = null,
}: UseNavigationFooterProps) => {
  // Show previous for any step > 1, including draft edit mode.
  const showPreviousButton = useMemo(() => {
    return currentStep > 1;
  }, [currentStep]);

  // Determinar el texto del botón anterior
  const previousButtonText = useMemo(() => {
    return 'Anterior';
  }, []);

  // Determinar el texto del botón siguiente
  const nextButtonText = useMemo(() => {
    return currentStep < 3 ? 'Siguiente' : 'Finalizar';
  }, [currentStep]);

  // Determinar el aria-label del botón siguiente
  const nextButtonAriaLabel = useMemo(() => {
    return currentStep < 3 ? 'Next step' : 'Finalize';
  }, [currentStep]);

  // Determinar si el botón siguiente está deshabilitado
  const isNextButtonDisabled = useMemo(() => {
    return isNextDisabled;
  }, [isNextDisabled]);

  // Show save draft button on steps 1 and 2 (not on step 3 where finalizar is)
  const showSaveDraftButton = useMemo(() => {
    return currentStep < 3 && onSaveDraft != null;
  }, [currentStep, onSaveDraft]);

  return {
    showPreviousButton,
    previousButtonText,
    nextButtonText,
    nextButtonAriaLabel,
    isNextButtonDisabled,
    showSaveDraftButton,
    onPrevious,
    onNext,
    currentStep,
  };
};
